
import React, { useEffect, useState } from "react";
import { makeStyles } from 'tss-react/mui';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles()(theme => ({
	chips: {
		display: "flex",
		flexWrap: "wrap",
	},
	chip: {
		margin: 2,
	},
}));

const ContactCategoriSelect = ({ select, onChange }) => {
	const { classes } = useStyles();
	const [categorys, setCategorys] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const { data }   = await api.get("/contactscategory");
				setCategorys(data.category);

			} catch (err) {
				toastError(err);
			}
		})();
	}, []);

	const handleChange = e => {
		onChange(e.target.value);
	};

	return (
		<div >
			<FormControl fullWidth margin="dense" variant="outlined">
				<Typography variant="subtitle1" gutterBottom>
					Categoria del cliente
				</Typography>
				<Select
					labelWidth={120}
					value={select}
					onChange={handleChange}
				>

					{categorys.map(categorys => (
						<MenuItem key={categorys.id} value={categorys.id}>
							{categorys.name}
						</MenuItem>
					))}

					
				</Select>

				

			</FormControl>
		</div>
	);
};

export default ContactCategoriSelect;
